import { render, staticRenderFns } from "./EditCMPage.vue?vue&type=template&id=54b18a89&"
import script from "./EditCMPage.vue?vue&type=script&lang=js&"
export * from "./EditCMPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports